import { createSlice } from '@reduxjs/toolkit';

import { IPanelLink } from '../../models/dataset/DatasetRelated';
import TGeneralUserConfig from '../../models/user-config/GeneralUserConfig';

import { failureAction, pendingAction, successAction } from './actionHandler';

interface UserConfigState {
  readonly panelLinks: IPanelLink[];
  readonly general: TGeneralUserConfig;
}

const initialState: UserConfigState = {
  panelLinks: [],
  general: {},
};

const userConfigSlice = createSlice({
  name: 'userConfig',
  initialState,
  reducers: {
    savePanelLinks: pendingAction<UserConfigState, IPanelLink[]>(),
    savePanelLinksSuccess: successAction<UserConfigState, IPanelLink[]>(
      (state, { payload }) => {
        state.panelLinks = payload;
      }
    ),
    savePanelLinksFailure: failureAction(),
    getPanelLinks: pendingAction(),
    getPanelLinksSuccess: successAction<UserConfigState, IPanelLink[]>(
      (state, { payload }) => {
        state.panelLinks = payload;
      }
    ),
    getPanelLinksFailure: failureAction(),
    saveGeneral: pendingAction<
      UserConfigState,
      { config: TGeneralUserConfig; application?: string }
    >(),
    saveGeneralSuccess: successAction<UserConfigState, TGeneralUserConfig>(
      (state, { payload }) => {
        state.general = payload;
      }
    ),
    saveGeneralFailure: failureAction(),
    getGeneral: pendingAction(),
    getGeneralSuccess: successAction<UserConfigState, TGeneralUserConfig>(
      (state, { payload }) => {
        state.general = payload;
      }
    ),
    getGeneralFailure: failureAction(),
  },
});

export const userConfigReducer = userConfigSlice.reducer;

export default userConfigSlice.actions;
